export class ClientePessoaFisica {
  constructor(data = {}) {
    this.base64Imagem = data.base64Imagem;
    this.tipoImagem = "IMAGEM_ROSTO";
    this.nrSeqEndereco = data.nrSeqEndereco;
    this.id = data.id || null;
    this.nome = data.nome || "";
    this.email = data.email || "";
    this.numeroDocumento = data.numeroDocumento || "";
    this.numeroDocumentoAlternativo = data.numeroDocumentoAlternativo || "";
    this.tipoDocumento = "";
    this.celular = data.celular || "";
    this.telefone = data.telefone || "";
    this.logradouro = data.logradouro || "";
    this.bairro = data.bairro || "";
    this.cidade = data.cidade || "";
    this.uf = data.uf || 0;
    this.cep = data.cep || "";
    this.numero = data.numero || "";
    this.complemento = data.complemento || "";
    this.latitude = data.latitude || 0;
    this.longitude = data.longitude || 0;
    this.nomeMae = data.nomeMae || "";
    this.nomePai = data.nomePai || "";
    this.nomeSocial = data.nomeSocial || "";
    this.sexo = data.sexo || "";
    this.dataNascimento = data.dataNascimento || "";
    this.idTipoLogradouro = data.idTipoLogradouro || 1;
    this.idTipoEndereco = data.idTipoEndereco || 1;
    this.idTiposPerfisCliente = [];
    this.senha = "";
    this.confirmacaoSenha = "";
    this.idOperadora = null;
  }
}

export class TipoEndereco {
  constructor(data = {}) {
    this.codigo = data.codigo || null;
    this.descricao = data.descricao || null;
  }
}

export class TipoLogradouro {
  constructor(data = {}) {
    this.id = data.id || null;
    this.descricao = data.descricao || null;
  }
}

export class Endereco {
  constructor(data = {}) {
    this.nrSeqEndereco = data.nrSeqEndereco || null;
    this.logradouro = data.logradouro || "";
    this.bairro = data.bairro || "";
    this.cidade = data.cidade || "";
    this.uf = data.uf || "";
    this.cep = data.cep || "";
    this.numero = data.numero || "";
    this.complemento = data.complemento || "";
    this.latitude = data.latitude || 0.0;
    this.longitude = data.longitude || 0.0;
    this.tipoEndereco = new TipoEndereco(data.tipoEndereco);
    this.tipoLogradouro = new TipoLogradouro(data.tipoLogradouro);
  }
}

export const TipoDocumento = {
  CPF: "CPF",
  CNPJ: "CNPJ",
};

export const TipoCliente = {
  EMPRESA: 1,
  USUARIO: 2,
  PERMISSIONARIO: 3,
  MOTORISTA: 4,
  OPERADORA: 5,
  LOJA: 8,
  VENDEDOR: 9,
  ALUNO: 10,
  COLABORADOR: 11,
};
